import { View } from "react-native";
import { TextActionButton } from "@louise/moon-ui";
import { useTranslations } from "@src/packages/i18n";

/**
 * Shows an embryo's sex she is keeping a surprise. One press reveals it
 * everywhere in the view (see useEmbryoSexDisclosure).
 */
export default function ShowEmbryoSexButton({
  onPress,
}: {
  onPress: () => void;
}) {
  const t = useTranslations();
  return (
    <View style={{ alignItems: "flex-start" }}>
      <TextActionButton
        label={t("care.embryo_sex.show_embryo_sex")}
        onPress={onPress}
        action="reveal_embryo_sex"
        style={{ paddingHorizontal: 0, paddingVertical: 0 }}
      />
    </View>
  );
}
